import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum LeadTagId {
  RECEPTION_SYSTEM = 1,
  RESERVATION_SYSTEM = 2,
  CHANNEL_MANAGER = 3,
  PAYMENT_GATEWAY_AND_TERMINAL = 4,
  WEBSITE = 5,
  ALFRED = 6,
  MOBILE_APPLICATION_PMS = 7,
  MOBILE_APPLICATION_HOUSEKEEPING = 8,
  MARKETING_PLUS = 9,
  EKASA = 10,
  REQUEST_FOR_DEMO = 11,
  RECEPTION_SYSTEM_PRESENTATION = 12,
  ACCESS_TO_DEMO_VERSION = 13,
  PRICE_LIST = 14,
  HOMEPAGE = 15,
  SWITCH_TO_PREVIO = 16,
  I_AM_INTERESTED = 17,
  SCAN_ID = 18,
  AUTOMATION = 19,
  PRICE_LIST_VERSION_2 = 20,
  CONSULTATION = 21,
  REGISTRATION = 22,
  MEGAUBYTKO_CZ_CAMPAIGN = 23,
  MEGAUBYTOVANIE_SK_CAMPAIGN = 24,
  DEVELOPMENT_PROGRAM = 25,
  RESERVATION_OFFERS = 26,
}

export class LeadTag extends Codebook<LeadTagId> {
  static readonly RECEPTION_SYSTEM = new LeadTag(LeadTagId.RECEPTION_SYSTEM, () =>
    $t('Reception System'),
  )

  static readonly RESERVATION_SYSTEM = new LeadTag(LeadTagId.RESERVATION_SYSTEM, () =>
    $t('Reservation System'),
  )

  static readonly CHANNEL_MANAGER = new LeadTag(LeadTagId.CHANNEL_MANAGER, () =>
    $t('Channel Manager'),
  )

  static readonly PAYMENT_GATEWAY_AND_TERMINAL = new LeadTag(
    LeadTagId.PAYMENT_GATEWAY_AND_TERMINAL,
    () => $t('Payment Gateway and Terminal'),
  )

  static readonly WEBSITE = new LeadTag(LeadTagId.WEBSITE, () => $t('Website'))

  static readonly ALFRED = new LeadTag(LeadTagId.ALFRED, () => $t('Alfred'))

  static readonly MOBILE_APPLICATION_PMS = new LeadTag(LeadTagId.MOBILE_APPLICATION_PMS, () =>
    $t('Mobile Application PMS'),
  )

  static readonly MOBILE_APPLICATION_HOUSEKEEPING = new LeadTag(
    LeadTagId.MOBILE_APPLICATION_HOUSEKEEPING,
    () => $t('Mobile Application Housekeeping'),
  )

  static readonly MARKETING_PLUS = new LeadTag(LeadTagId.MARKETING_PLUS, () => $t('Marketing+'))

  static readonly EKASA = new LeadTag(LeadTagId.EKASA, () => $t('eKasa'))

  static readonly REQUEST_FOR_DEMO = new LeadTag(LeadTagId.REQUEST_FOR_DEMO, () =>
    $t('Request for demo'),
  )

  static readonly RECEPTION_SYSTEM_PRESENTATION = new LeadTag(
    LeadTagId.RECEPTION_SYSTEM_PRESENTATION,
    () => $t('Reception System Presentation'),
  )

  static readonly ACCESS_TO_DEMO_VERSION = new LeadTag(LeadTagId.ACCESS_TO_DEMO_VERSION, () =>
    $t('Access to Demo Version'),
  )

  static readonly PRICE_LIST = new LeadTag(LeadTagId.PRICE_LIST, () => $t('Price List'))

  static readonly HOMEPAGE = new LeadTag(LeadTagId.HOMEPAGE, () => $t('Homepage'))

  static readonly SWITCH_TO_PREVIO = new LeadTag(LeadTagId.SWITCH_TO_PREVIO, () =>
    $t('Switch to Previo'),
  )

  static readonly I_AM_INTERESTED = new LeadTag(LeadTagId.I_AM_INTERESTED, () =>
    $t('I am Interested'),
  )

  static readonly SCAN_ID = new LeadTag(LeadTagId.SCAN_ID, () => $t('ScanId'))

  static readonly AUTOMATION = new LeadTag(LeadTagId.AUTOMATION, () => $t('Automation'))

  /** @deprecated */
  static readonly PRICE_LIST_VERSION_2 = new LeadTag(LeadTagId.PRICE_LIST_VERSION_2, () =>
    $t('Price List Version 2'),
  )

  static readonly CONSULTATION = new LeadTag(LeadTagId.CONSULTATION, () => $t('Consultation'))

  static readonly REGISTRATION = new LeadTag(LeadTagId.REGISTRATION, () => $t('New Registration'))

  static readonly MEGAUBYTKO_CZ_CAMPAIGN = new LeadTag(LeadTagId.MEGAUBYTKO_CZ_CAMPAIGN, () =>
    $t('Megaubytko.cz campaign'),
  )

  static readonly MEGAUBYTOVANIE_SK_CAMPAIGN = new LeadTag(
    LeadTagId.MEGAUBYTOVANIE_SK_CAMPAIGN,
    () => $t('Megaubytovanie.sk campaign'),
  )

  static readonly DEVELOPMENT_PROGRAM = new LeadTag(LeadTagId.DEVELOPMENT_PROGRAM, () =>
    $t('Development program'),
  )

  static readonly RESERVATION_OFFERS = new LeadTag(LeadTagId.RESERVATION_OFFERS, () =>
    $t('Reservation Offers'),
  )

  private constructor(
    id: LeadTagId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
